module.exports = __webpack_public_path__ + "img/linjie-empty.847807e2.png";